<script setup lang="ts">
import Button from './Button/Button.vue'

defineEmits(['delete'])
</script>

<template>
  <div
    class="bg-neutral-light-10 border-neutral-dark-3/15 inline-flex h-8 items-center space-x-1.5 rounded-sm border pl-2.5 text-xs text-nowrap"
  >
    <span><slot /></span>
    <Button
      class="h-full border-none pr-2"
      icon="circle-xmark"
      square
      @click="$emit('delete')"
    />
  </div>
</template>
